'use strict';

function CompanyMessageService($resource, config) {
  return $resource(config.apiBase + '/companies/:companyId/posts/:messageId', {}, {
    "update": {
      method: "PUT"
    },
    "delete": {
      method: "DELETE"
    },
    "sendMail": {
      method: "POST",
      url: config.apiBase + '/companies/:companyId/posts/:messageId/send-mail'
    }
  });
}

angular.module('dokiv')
  .factory('CompanyMessageService', ['$resource', 'config', CompanyMessageService]);



//////////////////
// WEBPACK FOOTER
// ./scripts/company/blogs/CompanyMessageService.js
// module id = 25
// module chunks = 0